module.exports = __webpack_public_path__ + "img/img14.2c1a1ad5.svg";